import { FC, useState, useEffect } from "react";
import useBoolean from "src/hooks/useBoolean";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Header from "src/components/Header";
import BlockList from "src/components/BlockList";
import { Divider } from "@material-ui/core";
import Chat from "src/components/Chat";
import { connect } from "src/store/connect";
import Canvas from "src/components/Canvas";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { ROOT_NODE_ID } from "src/config/constants";
import { State } from "src/store/state";
import DeployFlow from "src/components/DeployFlow"
import mixpanel from "mixpanel-browser";

interface PlaygroundProps {
  store: State;
}

const Playground: FC<PlaygroundProps> = ({ store }) => {
  const classes = useStyles();
  const [showChat, setShowChat] = useState(false);
  const [isDeployModalOpen, openDeployModal, closeDeployModal] = useBoolean();

  useEffect(() => {
    let rootExists = false
    store.flow.nodes.find((node) => {
      if(node.id === ROOT_NODE_ID) {
        rootExists = true
        return
      }
    })
    if (!rootExists) {
      store.addBlock({ parentId: ROOT_NODE_ID, id: ROOT_NODE_ID, outgoingMessage: "", type: "root"})
      store.addPlaceholder(ROOT_NODE_ID)
    }

    store.organizeFlow()

    store.highlightCurrentBlock();
  }, []);

  const sendUserMessage = (message: Message) => {
    if (store.messages.length <= 1) {
      mixpanel.track('simulator_conversation_started')
    }

    store.messages.push(message);
    store.moveToNextBlock(message.text);
  };

  const beforeStartSimulation = () => {
    store.setInitialHighlight();
    store.highlightCurrentBlock();
    store.moveToNextBlock("");
  };

  const afterStopSimulation = () => {
    store.resetBlocksHighlight();
    store.resetCurrentBlock();
  };

  const onStartSimulation = () => {
    beforeStartSimulation();
    store.simulationRunning = true
    setShowChat(true);

    mixpanel.track('simulator_opened')
  };

  const onStopSimulation = () => {
    store.simulationRunning = false
    setShowChat(false);
    afterStopSimulation();
  };

  const onDeploy = () => {
    openDeployModal()
    mixpanel.track('deploy_flow_opened')
  };

  document.addEventListener("DOMContentLoaded", function (event) {
    store.organizeFlow();
  });

  return (
    <div className={classes.root}>
      <Header onStartSimulation={onStartSimulation} onDeploy={onDeploy} />
      <DeployFlow onClose={closeDeployModal} isOpen={isDeployModalOpen} />
      <DndProvider backend={HTML5Backend}>
        <BlockList />
        <Divider className={classes.marginTop}></Divider>
        {showChat && (
          <Chat
            sendMessage={sendUserMessage}
            onStopSimulation={onStopSimulation}
          />
        )}
        <Canvas />
      </DndProvider>
    </div>
  );
};

Playground.defaultProps = {};

export default connect(Playground);

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  marginTop: {
    marginTop: "24px",
  },
}));
